import { NgClass } from '@angular/common'
import { Component, computed, input, output } from '@angular/core'
import { EventWizardStep } from '../../enums/event.enum'

@Component({
  selector: 'app-stepper',
  imports: [NgClass],
  templateUrl: './stepper.component.html',
  styleUrl: './stepper.component.scss'
})
export class StepperComponent {
  currentStep = input<number>(1)
  totalSteps = input.required<EventWizardStep>()

  stepChanged = output<number>()

  /**
   * Get array of step numbers for iteration
   */
  public steps = computed(() => {
    return Array.from({ length: this.totalSteps() }, (_, i) => i + 1)
  })

  /**
   * Check if previous button should be shown
   */
  public showPreviousButton = computed(() => {
    return this.currentStep() > 1
  })

  /**
   * Check if next button should be shown
   */
  public showNextButton = computed(() => {
    return this.currentStep() < this.totalSteps()
  })

  /**
   * Handle step indicator click
   * @param stepIndex {number} - The step index (1-indexed)
   */
  public onStepClick(stepIndex: number): void {
    if (stepIndex >= 1 && stepIndex <= this.totalSteps()) {
      this.stepChanged.emit(stepIndex)
    }
  }

  /**
   * Handle previous button click
   */
  public onPreviousClick(): void {
    if (this.currentStep() > 1) {
      this.stepChanged.emit(this.currentStep() - 1)
    }
  }

  /**
   * Handle next button click
   */
  public onNextClick(): void {
    if (this.currentStep() < this.totalSteps()) {
      this.stepChanged.emit(this.currentStep() + 1)
    }
  }
}
